var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3181 12.2873C22.8318 12.2985 23.3484 12.2646 23.86 12.3049C24.3782 12.4016 24.5031 13.1859 24.0427 13.4428C23.7287 13.6121 23.3555 13.5059 23.015 13.5357H22.3181V12.2873V12.2873ZM24.1571 10.8743C24.2712 11.2771 23.8829 11.6388 23.4949 11.5833H22.3181C22.3264 11.2035 22.302 10.7911 22.3301 10.4313C22.8015 10.4445 23.2773 10.4042 23.7459 10.4524C23.9473 10.5029 24.1158 10.6685 24.1571 10.8743V10.8743ZM26.989 4.90047C27.0109 5.66977 26.9922 6.47973 26.9985 7.26464C26.997 10.4558 27.0015 13.6468 26.996 16.8382C26.9753 18.0341 25.9154 19.0733 24.7277 19.0972C23.5389 19.102 22.3499 19.0979 21.1609 19.0993V14.2749C22.4563 14.2682 23.7525 14.2885 25.0474 14.2648C25.6481 14.2271 26.3061 13.8307 26.3341 13.1696C26.4048 12.5057 25.7789 12.0465 25.1846 11.9739C24.9561 11.968 24.9628 11.9073 25.1846 11.8809C25.7514 11.7584 26.1965 11.1717 26.0297 10.5842C25.8876 9.96623 25.2046 9.72705 24.6365 9.72824C23.4781 9.72037 22.3196 9.72714 21.1611 9.72486C21.1686 8.82421 21.1455 7.92259 21.1736 7.02261C21.2654 5.84824 22.352 4.87976 23.5229 4.90077C24.6784 4.9006 25.8338 4.9006 26.989 4.90055V4.90047Z",
    fill: "url(#paint0_linear_6391_45926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07061 7.14442C8.10019 5.95035 9.16462 4.91968 10.3508 4.90223C11.5352 4.89858 12.7198 4.9017 13.9043 4.90065C13.901 8.89573 13.9107 12.8913 13.8994 16.8861C13.8538 18.0657 12.8009 19.0767 11.6277 19.0976C10.441 19.1019 9.25421 19.0982 8.06749 19.0994V14.1124C9.22019 14.3847 10.429 14.5006 11.6049 14.32C12.3079 14.2069 13.0769 13.8617 13.3149 13.1325C13.49 12.5086 13.3915 11.8521 13.4175 11.2119V9.72504H11.3824C11.3733 10.7084 11.4011 11.6935 11.3677 12.6757C11.3128 13.2794 10.715 13.663 10.1456 13.6425C9.43945 13.65 8.04014 13.1307 8.04014 13.1307C8.03663 11.2883 8.06063 8.98092 8.07061 7.14459V7.14442Z",
    fill: "url(#paint1_linear_6391_45926)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6632 10.3246C14.5561 10.3473 14.6417 9.95969 14.6143 9.81265C14.6216 8.88295 14.599 7.95224 14.6267 7.02319C14.7182 5.84385 15.8132 4.87296 16.9889 4.90057H20.4513C20.4481 8.89565 20.4577 12.8912 20.4464 16.886C20.4008 18.0656 19.3479 19.0766 18.1746 19.0975C16.9879 19.102 15.801 19.0982 14.6142 19.0994V13.6354C15.4248 14.3005 16.5264 14.404 17.5362 14.4058C18.2974 14.4055 19.0542 14.2882 19.7935 14.1126V13.1116C18.9604 13.5268 17.981 13.7906 17.0575 13.552C16.4132 13.3916 15.9456 12.769 15.956 12.1042C15.8813 11.4128 16.2866 10.6828 16.9661 10.4772C17.8097 10.2132 18.7291 10.4151 19.5198 10.7585C19.6892 10.8472 19.8612 10.9572 19.7934 10.674V9.88725C18.4709 9.5726 17.0635 9.45682 15.7349 9.79911C15.3503 9.9076 14.9756 10.0721 14.6632 10.3247V10.3246Z",
    fill: "url(#paint2_linear_6391_45926)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6391_45926",
    x1: 21.121,
    y1: 11.6963,
    x2: 26.9616,
    y2: 11.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6391_45926",
    x1: 7.9433,
    y1: 12.136,
    x2: 13.8086,
    y2: 12.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6391_45926",
    x1: 14.6057,
    y1: 11.8339,
    x2: 20.4502,
    y2: 11.8339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbLogo);
export default __webpack_public_path__ + "static/media/jcbLogo.720aae4f4175e503f0a684aac2dba29a.svg";
export { ForwardRef as ReactComponent };